import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * 원본: .references/gc-mono/apps/gc-zoku/redux/modules/helpers.js
 * 스피너, 에러 모달 등 전역 UI 상태
 */

interface ApiError {
  message: string;
  code?: number;
}

interface HelpersState {
  spinnerCounter: number;
  errors: ApiError[];
  errorsModalIsOpen: boolean;
}

const initialState: HelpersState = {
  spinnerCounter: 0,
  errors: [],
  errorsModalIsOpen: false,
};

const helpersSlice = createSlice({
  name: 'helpers',
  initialState,
  reducers: {
    showSpinner(state) {
      state.spinnerCounter += 1;
    },
    hideSpinner(state) {
      state.spinnerCounter = Math.max(0, state.spinnerCounter - 1);
    },
    showError(state, action: PayloadAction<ApiError>) {
      state.errors = [...state.errors.slice(-4), action.payload];
      state.errorsModalIsOpen = true;
    },
    hideError(state) {
      state.errorsModalIsOpen = false;
    },
  },
});

export const { showSpinner, hideSpinner, showError, hideError } = helpersSlice.actions;
export default helpersSlice.reducer;
